import React, { useEffect, useState } from 'react';
import Breadcrumbs from '../../../components/BreadCrumbs';
import Pagination from '../../../components/tables/pagination/Pagination';
import CustomLoading from '../../../components/customLoading/CustomLoading';
import Table from '../../../components/tables/Table';
import loaderImage from "../../../assets/icons/part-logo.png";
import StyledHeadingText from '../../../components/Fonts/StyledHeadingText';
import Card from '../../../components/cards/Card';
import { toast } from 'react-toastify';
import { getHudPatients, updateHudPatientDoctorView } from '../../../services/hud/hud_patients';
import { Link } from 'react-router-dom';
import { BiCheckCircle, BiEdit, BiHistory, BiImages, BiPencil, BiSolidCheckCircle } from 'react-icons/bi';
import { GoPackage } from 'react-icons/go';
import Button from '../../../components/buttons/Button';
import { LuFileScan } from 'react-icons/lu';
import SearchBar from '../../../components/searchBar/SearchBar';
import { formatDateTime } from '../../../utils/FormatDateTime';


function HudPatients() {
    const [cardData, setCardData] = useState([]);

    const [tableData, setTableData] = useState({});
    const headers = [
        { label: "Edit", key: "edit" },
        { label: "Files", key: "files" },
        { label: "History", key: "history" },
        { label: "Package", key: "package" },
        { label: "Show", key: "dr" },
        { label: "S/N", key: "sn" },
        { label: "Name", key: "full_name" },
        { label: "Gender", key: "gender" },
        { label: "Address", key: "address" },
        { label: "Phone", key: "phone_number" },
        { label: "Addon", key: "date" },
        { label: "Skin Type", key: "skin_type" },
        { label: "System Code", key: "system_code" },
        { label: "Machine", key: "machine_name" },
    ];

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);

    const pageSize = 10;

    const fetchData = async (query) => {
        setLoading(true);
        try {
            let res = await getHudPatients(query);
            if (res.status === 200) {
                setTableData(res.data);
            } else {
                toast.error("Unable to fetch Patients");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching Patients:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = (query) => {
        fetchData("?search=" + query);
    };

    const handleDrView = async (item) => {
        setLoading(true);
        try {
            let res = await updateHudPatientDoctorView(item.patient_id);
            if (res.status === 200) {
                fetchData("");
                toast.success(`${item.full_name} activated on doctor's view`);
            } else {
                toast.error("Unable to change deoctor view");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error updating doctor view:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData("");
    }, []);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    return (<>
        <div className="flex flex-row justify-between items-center">
            <div className="flex flex-row gap-1">
                <Breadcrumbs items={[
                    { name: 'Home', link: '/invoice' },
                    { name: 'Patients' },
                ]} />
                <StyledHeadingText text={"| Patients"} size={"text-xs"} />
            </div>
            <Link to="/hud-patients/add">
                <Button
                    type="button"
                    className="bg-primary text-xs text-white px-4 py-2 rounded"
                    disabled={loading}
                >
                    Add Patient
                </Button>
            </Link>
        </div>
        <div className="py-1">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 mt-2">
                {cardData.map((card, index) => (
                    <Card title={card.title} count={card.count} />
                ))}
            </div>
        </div>
        <div className="bg-white p-4 w-full rounded border-primary border-t-2">
            <div className="flex flex-row justify-end">
                <div className="md:w-[30%] lg:w-[20%] self-end">
                    <SearchBar placeholder="Search Patients..." onSearch={handleSearch} />
                </div>
            </div>
            {
                loading ?
                    <div className="flex w-full flex-row justify-center my-2">
                        <CustomLoading imageSrc={loaderImage} size={100} />
                    </div>
                    :
                    <div className="mt-2">
                        <Table
                            headers={headers}
                            rows={tableData?.results?.map((item, index) => (
                                {
                                    edit: <Link to={`/hud-patients/${item.patient_id}/`} state={item}><BiPencil size={17} color='blue' /></Link>,
                                    files: <Link to={`/hud-patients/files/`} state={item}><LuFileScan size={17} color='purple' /></Link>,
                                    history: <Link to={`/hud-patients/history/`} state={item}><BiHistory size={17} color='red' /></Link>,
                                    package: <Link to={`/hud-patients/packages/`} state={item}><GoPackage size={17} color='green' /></Link>,
                                    dr: <Button onClick={() => handleDrView(item)}>{item.is_activated ? <BiSolidCheckCircle size={17} color='orange' /> : <BiCheckCircle size={17} color='black' />}</Button>,
                                    full_name: <b className='text-black'>{item.full_name}</b>,
                                    address: <p>{item.city}</p>,
                                    gender: <p className='w-full text-center'>{item.gender}</p>,
                                    phone_number: <p>{item.phone_number}</p>,
                                    machine_name: <p>{item.machine_name}</p>,
                                    sn: <p>{item.sn ?? "-"}</p>,
                                    skin_type: <p>{item.skin_type}</p>,
                                    system_code: <p>{item.system_code}</p>,
                                    date: <p>{formatDateTime(item.date)}</p>,
                                }))}
                        />
                    </div>}
            {
                tableData.count !== 0 ?
                    <div className="xl:pl-5 pl-0">
                        <Pagination
                            currentPage={currentPage}
                            totalPages={Math.ceil(tableData?.count / pageSize)}
                            pageSize={pageSize}
                            totalEntries={tableData?.count}
                            onPageChange={handlePageChange}
                            data={tableData}
                            setTableData={setTableData}
                        />
                    </div> : <></>
            }
        </div>
    </>);
}

export default HudPatients;